import { decamelizeKeys } from 'humps';
import { useEffect } from 'react';
import io from 'socket.io-client';

const sockets = {
  default: {
    io: null,
    joinRoom: null,
    leaveRoom: null
  }
};

const joinedRooms = {
  default: {}
};

const joinRoom = (namespace, type, id) => {
  const socket = sockets[namespace];

  if (joinedRooms[namespace] && joinedRooms[namespace][type]) {
    leaveRoom(namespace, type, joinedRooms[namespace][type]);
  }

  socket.io.emit(`join_${type}`, { [`${type}_id`]: id });
  joinedRooms[namespace] = { ...joinedRooms[namespace], [type]: id };
};

const leaveRoom = (namespace, type, id) => {
  const socket = sockets[namespace];

  socket.io.emit(`leave_${type}`, { [`${type}_id`]: id });
  const { [type]: _, ...remainingRooms } = joinedRooms[namespace] || {};
  joinedRooms[namespace] = remainingRooms;
};

const useSocket = (accessToken, organizationId, namespace = 'default') => {
  useEffect(() => {
    // Disconnect existing socket if token changes
    if (sockets[namespace]?.io && sockets[namespace].accessToken !== accessToken) {
      sockets[namespace].io.disconnect();
      sockets[namespace] = null;
    }

    if (!sockets[namespace]?.io) {
      sockets[namespace] = {
        accessToken // Store the token to check for changes
      };

      sockets[namespace].io = io(process.env.REACT_APP_WEBSOCKET_URL, {
        path: namespace ? `/${namespace}/socket.io` : '/socket.io',
        transports: ['websocket'],
        query: decamelizeKeys({ token: accessToken, organizationId })
      });

      const socket = sockets[namespace];

      socket.io.on('connect', () => {
        const rooms = Object.entries(joinedRooms[namespace] || {});

        if (rooms) {
          rooms.forEach(([type, id]) => {
            joinRoom(namespace, type, id);
          });
        }
      });

      socket.joinRoom = (type, id) => joinRoom(namespace, type, id);
      socket.leaveRoom = (type, id) => leaveRoom(namespace, type, id);
    }

    return () => {
      Object.entries(joinedRooms[namespace] || {}).forEach(([type, id]) => {
        leaveRoom(namespace, type, id);
      });
    };
  }, [accessToken, organizationId, namespace]);

  return sockets[namespace] || {};
};

export { useSocket };
